import dynamic from 'next/dynamic';
import { Box, Container, Divider, Grid, Typography } from '@mui/material';
import useIsMobile from 'hooks/useIsMobile';
import Image from 'next/image';
import LazyLoad from 'react-lazyload';
import { COLOR_PURPLE_HOVER } from 'styles/variables/colors';
import Header from '../Header';
import { useStyles } from './styles';
import PageFooter from 'components/PageFooter';
import PageFooterMobile from 'components/PageFooterMobile';

const DynamicTestimonials = dynamic(() => import('components/Testimonials'));
const DynamicTestimonialsMobile = dynamic(() => import('components/TestimonialsMobile'));
const DynamicStepsSection = dynamic(() => import('components/StepsSection'));
const DynamicInfodesignKorean = dynamic(() => import('../InfoDesignKorean'));
const DynamicPricingContentKorean = dynamic(() => import('../Pricing'));
const DynamicFaq = dynamic(() => import('../Faq'));

export default function MainContentKorean() {
  const classes = useStyles();
  const isMobile = useIsMobile();

  return (
    <>
      <Header />

      {/* <div id="pricing">
        <DynamicPricingContentKorean title="요금제" />
      </div> */}

      <Box px={6} py={6} bgcolor="#F1F1F1">
        <Container>
          <LazyLoad>
            <Grid container={true} spacing={2} alignItems="center">
              <Grid item={true} xs={12} md={6}>
                <Image
                  src="/images/science-figures/templates.webp"
                  width={655}
                  height={541}
                  alt="Science figures templates"
                  loading="lazy"
                  objectFit="contain"
                  responsive
                />
              </Grid>

              <Grid item={true} xs={12} md={6}>
                <Box pl={!isMobile && 14}>
                  <Box pb={3}>
                    <Image
                      src="/images/science-figures/templates-icon.webp"
                      width={60}
                      height={64}
                      alt="templates icon"
                      loading="lazy"
                    />

                    <Typography variant="h5" component="h2" className={classes.primaryColor}>
                      <b>200개 이상의 과학/학술 디자인 템플릿</b>
                    </Typography>
                  </Box>

                  <Typography variant="h6" component="p">
                    바로 사용 가능한 과학/학술에 맞춤 제작된 디자인으로 연구 프로젝트를 빠르게
                    시작하세요.
                  </Typography>
                </Box>
              </Grid>
            </Grid>

            <Box pt={6} pb={3}>
              <Divider />
            </Box>
          </LazyLoad>
        </Container>
      </Box>

      <Box bgcolor="#F1F1F1">
        <Container>
          <LazyLoad>
            <Grid container={true} spacing={2} alignItems="center">
              <Grid item={true} xs={12} md={6}>
                <Box ml={!isMobile ? 6 : 0} px={isMobile ? 6 : 0}>
                  <Image
                    src="/images/science-figures/illustration-icon.webp"
                    width={51}
                    height={59}
                    alt="illustration icon"
                    loading="lazy"
                  />

                  <Typography variant="h5" component="h2" className={classes.primaryColor}>
                    <b>세계 최대 규모의 과학 일러스트 갤러리</b>
                  </Typography>

                  <Typography variant="h6" component="p">
                    과학자와 연구자가 선별한 완성도 높은 디자인 템<br />
                    플릿으로 연구를 효과적으로 전달하기 위해 시각
                    <br />
                    화하세요.
                  </Typography>
                </Box>
              </Grid>

              <Grid item={true} xs={12} md={6}>
                <Box ml={!isMobile && -12}>
                  <Image
                    className={classes.sectionImage}
                    src="/images/science-figures/illustrations.webp"
                    width={606}
                    height={391}
                    alt="Science figures illustrations"
                    loading="lazy"
                    objectFit="contain"
                    responsive
                  />
                </Box>
              </Grid>
            </Grid>

            <Box py={6}>
              <Divider />
            </Box>
          </LazyLoad>
        </Container>
      </Box>

      <Box bgcolor="#F1F1F1" pb={6}>
        <Container>
          <LazyLoad>
            <Grid container={true} spacing={2} alignItems="center">
              <Grid item={true} xs={12} md={6}>
                <Image
                  src="/images/science-figures/keep-readers.webp"
                  width={593}
                  height={461}
                  alt="Keed readers interested with science figures"
                  loading="lazy"
                  responsive
                />
              </Grid>

              <Grid item={true} xs={12} md={6}>
                <Box ml={!isMobile ? 6 : 0} px={isMobile ? 6 : 0}>
                  <Image
                    src="/images/science-figures/keep-readers-icon.webp"
                    width={77}
                    height={56}
                    alt="Keed readers interested icon"
                    loading="lazy"
                  />

                  <Typography variant="h5" component="h2" className={classes.primaryColor}>
                    <b>눈길가는 디자인으로 독자들의 흥미 유도</b>
                  </Typography>

                  <Typography variant="h6" component="p">
                    지루한 텍스트보다 눈길이 가는 이미지로 독자들에게 강력한 메세지를 전달해보세요
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </LazyLoad>
        </Container>
      </Box>

      <Box bgcolor={COLOR_PURPLE_HOVER}>
        <DynamicStepsSection
          title="Mind the graph 로 과학 일러스트 제작 방법"
          labels={[
            '회원 가입 후 신규 템플릿 생성',
            '이미지 크기 선택 및 크기 조정 / 사이즈 직접 입력',
            '다양한 형식의 이미지 다운로드 지원(PNG, PDF, TIFF 등)',
          ]}
        />
      </Box>

      <DynamicInfodesignKorean />

      <Box py={8} bgcolor="#F1F1F1">
        <Container>
          <DynamicFaq />
        </Container>
      </Box>

      <Box bgcolor="#F1F1F1" pb={6}>
        <Container>
          {isMobile ? (
            <DynamicTestimonialsMobile showActionButton={false} />
          ) : (
            <DynamicTestimonials showActionButton={false} />
          )}
        </Container>
      </Box>

      {isMobile ? <PageFooterMobile localeProp="ko" /> : <PageFooter localeProp="ko" />}
    </>
  );
}
